import { createRoutine, bindRoutineToReduxForm } from "redux-saga-routines";

// creating routine
export const addNameToCartRoutine = createRoutine("cart/ADD_NAME");
export const removeNameFromCartRoutine = createRoutine("cart/REMOVE_NAME");
export const emptyCartRoutine = createRoutine("cart/EMPTY");
